/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCheckinRouteImport } from './routes/_app/checkin'
import { Route as AppPassesRouteImport } from './routes/_app/passes'
import { Route as AppPosRouteImport } from './routes/_app/pos'
import { Route as AppScheduleRouteImport } from './routes/_app/schedule'
import { Route as AppShiftRouteImport } from './routes/_app/shift'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients.index'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients.$clientId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCheckinRoute = AppCheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => AppRoute,
} as any)
const AppPassesRoute = AppPassesRouteImport.update({
  id: '/passes',
  path: '/passes',
  getParentRoute: () => AppRoute,
} as any)
const AppPosRoute = AppPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleRoute = AppScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppRoute,
} as any)
const AppShiftRoute = AppShiftRouteImport.update({
  id: '/shift',
  path: '/shift',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/checkin': typeof AppCheckinRoute
  '/passes': typeof AppPassesRoute
  '/pos': typeof AppPosRoute
  '/schedule': typeof AppScheduleRoute
  '/shift': typeof AppShiftRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/clients/': typeof AppClientsIndexRoute
}
export interface FileRoutesByTo {
  '/checkin': typeof AppCheckinRoute
  '/passes': typeof AppPassesRoute
  '/pos': typeof AppPosRoute
  '/schedule': typeof AppScheduleRoute
  '/shift': typeof AppShiftRoute
  '/': typeof AppIndexRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/clients': typeof AppClientsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/checkin': typeof AppCheckinRoute
  '/_app/passes': typeof AppPassesRoute
  '/_app/pos': typeof AppPosRoute
  '/_app/schedule': typeof AppScheduleRoute
  '/_app/shift': typeof AppShiftRoute
  '/_app/': typeof AppIndexRoute
  '/_app/clients/$clientId': typeof AppClientsClientIdRoute
  '/_app/clients/': typeof AppClientsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/checkin'
    | '/passes'
    | '/pos'
    | '/schedule'
    | '/shift'
    | '/clients/$clientId'
    | '/clients/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/checkin'
    | '/passes'
    | '/pos'
    | '/schedule'
    | '/shift'
    | '/'
    | '/clients/$clientId'
    | '/clients'
  id:
    | '__root__'
    | '/_app'
    | '/_app/checkin'
    | '/_app/passes'
    | '/_app/pos'
    | '/_app/schedule'
    | '/_app/shift'
    | '/_app/'
    | '/_app/clients/$clientId'
    | '/_app/clients/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checkin': {
      id: '/_app/checkin'
      path: '/checkin'
      fullPath: '/checkin'
      preLoaderRoute: typeof AppCheckinRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/passes': {
      id: '/_app/passes'
      path: '/passes'
      fullPath: '/passes'
      preLoaderRoute: typeof AppPassesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos': {
      id: '/_app/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof AppPosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule': {
      id: '/_app/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AppScheduleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shift': {
      id: '/_app/shift'
      path: '/shift'
      fullPath: '/shift'
      preLoaderRoute: typeof AppShiftRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCheckinRoute: typeof AppCheckinRoute
  AppPassesRoute: typeof AppPassesRoute
  AppPosRoute: typeof AppPosRoute
  AppScheduleRoute: typeof AppScheduleRoute
  AppShiftRoute: typeof AppShiftRoute
  AppIndexRoute: typeof AppIndexRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCheckinRoute: AppCheckinRoute,
  AppPassesRoute: AppPassesRoute,
  AppPosRoute: AppPosRoute,
  AppScheduleRoute: AppScheduleRoute,
  AppShiftRoute: AppShiftRoute,
  AppIndexRoute: AppIndexRoute,
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
